// Shared by the header row and every field row so the columns line up.
export const FIELD_GRID =
  "md:grid md:grid-cols-[minmax(0,1fr)_150px_72px_64px_24px] md:items-start md:gap-x-4";
